// REGISTER
export const REGISTER_REQUEST = "AUTH.REGISTER_REQUEST";
export const REGISTER_SUCCESS = "AUTH.REGISTER_SUCCESS";
export const REGISTER_FAILURE = "AUTH.REGISTER_FAILURE";

// LOGIN
export const LOGIN_REQUEST = "AUTH.LOGIN_REQUEST";
export const LOGIN_SUCCESS = "AUTH.LOGIN_SUCCESS";
export const LOGIN_FAILURE = "AUTH.LOGIN_FAILURE";

// LOGIN WITH FACEBOOK
export const FACEBOOK_REQUEST = "AUTH.FACEBOOK_REQUEST";
export const FACEBOOK_SUCCESS = "AUTH.FACEBOOK_SUCCESS";
export const FACEBOOK_FAILURE = "AUTH.FACEBOOK_FAILURE";

// LOGIN WITH GOOGLE
export const GOOGLE_REQUEST = "AUTH.GOOGLE_REQUEST";
export const GOOGLE_SUCCESS = "AUTH.GOOGLE_SUCCESS";
export const GOOGLE_FAILURE = "AUTH.GOOGLE_FAILURE";

// LOGOUT
export const LOGOUT_REQUEST = "AUTH.LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "AUTH.LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "AUTH.LOGOUT_FAILURE";

// VERIFY
export const VERIFY_REQUEST = "AUTH.VERIFY_REQUEST";
export const VERIFY_SUCCESS = "AUTH.VERIFY_SUCCESS";
export const VERIFY_FAILURE = "AUTH.VERIFY_FAILURE";

// CHECK ROLE
export const CHECK_CURRENT_ROLE = "AUTH.CHECK_CURRENT_ROLE";
